import { jsx } from "panel";
import { SvgIconEl } from "common/components/svg-icon";
export function template() {
  if (!this.attr(`meta`)) {
    return null;
  }
  const { fromDate, toDate, title, subtitles } = this.helpers.getFormattedReportMeta();
  return /* @__PURE__ */ jsx("div", {
    sel: ".mp-download-wrapper-container"
  }, this.helpers.isFileDownload() ? /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", {
    sel: ".header"
  }, title ? /* @__PURE__ */ jsx("div", {
    sel: ".title"
  }, title) : null, fromDate && toDate ? /* @__PURE__ */ jsx("div", {
    sel: ".dates"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".from-date"
  }, fromDate), /* @__PURE__ */ jsx(SvgIconEl, {
    attrs: { icon: `arrow-right` }
  }), /* @__PURE__ */ jsx("div", {
    sel: ".to-date"
  }, toDate)) : null, /* @__PURE__ */ jsx("div", {
    sel: ".subtitle"
  }, subtitles.join(` \u2022 `))), /* @__PURE__ */ jsx("slot", null), /* @__PURE__ */ jsx("div", {
    sel: ".source"
  }, "Source:", /* @__PURE__ */ jsx("a", {
    sel: ".mp-link",
    attrs: { href: this.helpers.getReportLocation(), target: `_blank` }
  }, "Mixpanel"))) : /* @__PURE__ */ jsx("slot", null));
}
